import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
// data
import TestiMonialData from "./property-data.json";
// icon
import Icon from '@mdi/react';
import { mdiFormatQuoteClose, mdiStar } from '@mdi/js';

export default function Testimonial() {
    const [TestiMonialDataList] = useState(TestiMonialData);
    return (
        <>
            <section className='section' id='review'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='section-title-box'>
                                <h1 className='section-title'>What Our <span className='text-primary'>Client Says</span></h1>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <div className="testimonial-slider-content">
                                <Swiper className='testimonial-slider custom-slider pb-5'
                                    spaceBetween={24}
                                    loop={true}
                                    slidesPerView={'auto'}
                                    centeredSlides={true}
                                    pagination={{ dynamicBullets: true }}
                                    modules={[Autoplay, Pagination]}
                                    autoplay={{
                                        delay: 2500,
                                    }}
                                    breakpoints={{
                                        1: {
                                            slidesPerView: 1.2,
                                        },
                                        991: {
                                            slidesPerView: 2,
                                        },
                                        1200: {
                                            slidesPerView: 3,
                                        }
                                    }}
                                >
                                    {TestiMonialDataList.clientsListData.map((data, i) =>
                                        <SwiperSlide className='testi-slider' key={i}>
                                            <Card className='card-hover testi-slider-card'>
                                                <Card.Body>
                                                    <img src={require(`../../images/user-img/${data.clientImg}`)} alt="" className='testi-user-img avatar-img-lg rounded-circle img-shadow' />
                                                    <Icon path={mdiFormatQuoteClose} className='testi-quote-icon text-primary' />
                                                    <p className='text-muted fst-italic mt-3 pb-1'>"{data.clientReview}"</p>
                                                    <hr className='my-4' />
                                                    <div className='pt-1 d-flex align-items-center justify-content-between'>
                                                        <div>
                                                            <h5 className='mb-1 fs-16'>{data.clientName}</h5>
                                                            <p className='text-muted fs-15 mb-0'>{data.clientInfo}</p>
                                                        </div>
                                                        <div className='d-flex text-warning'>
                                                            <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                            <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                            <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                            <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                            <Icon path={mdiStar} className='icon-size-18' />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </SwiperSlide>
                                    )}
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
